import script from "./companyIntro.vue?vue&type=script&setup=true&lang=js"
export * from "./companyIntro.vue?vue&type=script&setup=true&lang=js"

import "./companyIntro.vue?vue&type=style&index=0&id=938bfe36&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-938bfe36"]])

export default __exports__